var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLeftArrowBlackSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88994 0.593076C6.15139 0.325995 6.58129 0.325995 6.84274 0.593076L7.0363 0.790799C7.28999 1.04995 7.28999 1.46436 7.0363 1.72351L2.74578 6.10642L7.03629 10.4893C7.28999 10.7485 7.28999 11.1629 7.03629 11.422L6.84274 11.6198C6.58129 11.8868 6.15139 11.8868 5.88994 11.6198L0.949347 6.57277C0.695657 6.31362 0.695657 5.89921 0.949347 5.64006L5.88994 0.593076Z",
    fill: "#0C002C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06859 11.4449C6.232 11.6118 6.50068 11.6118 6.66409 11.4449L6.85765 11.2472C7.0162 11.0852 7.0162 10.8262 6.85765 10.6642L2.39593 6.10642L6.85765 1.54863C7.0162 1.38666 7.0162 1.12765 6.85765 0.965683L6.66409 0.76796C6.50068 0.601034 6.232 0.601034 6.06859 0.767959L1.128 5.81494C0.969441 5.97691 0.96944 6.23592 1.128 6.39789L6.06859 11.4449ZM7.02139 11.7946C6.6619 12.1619 6.07079 12.1619 5.71129 11.7946L0.770698 6.74766C0.421874 6.39132 0.421874 5.82151 0.770698 5.46518L5.71129 0.418192C6.07079 0.0509566 6.6619 0.0509567 7.02139 0.418192L7.21495 0.615915C7.56377 0.972251 7.56377 1.54206 7.21495 1.8984L3.09563 6.10642L7.21494 10.3144C7.56377 10.6708 7.56377 11.2406 7.21494 11.5969L7.02139 11.7946Z",
    fill: "#0C002C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLeftArrowBlackSvg);
export default __webpack_public_path__ + "static/media/ico_left_arrow_black_svg.6342d4d7af11f0c472d00534f78e074b.svg";
export { ForwardRef as ReactComponent };